import React from "react";
import {
  FormControl,
  FormHelperText,
  OutlinedInput,
  InputAdornment,
  InputLabel,
  IconButton
} from "@material-ui/core";
import {
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon
} from "@material-ui/icons";

interface Props {
  label: string;
  value?: string;
  error?: string;
  disabled?: boolean;
  onChange: (password: string) => void;
}

const InputPassword: React.FC<Props> = props => {
  const { label, value, error, onChange } = props;
  const { disabled } = props;

  const [showPassword, setShowPassword] = React.useState(false);
  const handleShowPassword = React.useCallback(() => {
    setShowPassword(true);
  }, []);

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <FormControl error={!!error} variant="outlined" fullWidth>
      <InputLabel htmlFor={`standard-adornment-${label}`}>{label}</InputLabel>
      <OutlinedInput
        id={`standard-adornment-${label}`}
        type={showPassword ? "text" : "password"}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        label={label}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleShowPassword}
              onMouseDown={handleMouseDownPassword}
            >
              {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
            </IconButton>
          </InputAdornment>
        }
      />
      {error && <FormHelperText key={`error-${label}`}>{error}</FormHelperText>}
    </FormControl>
  );
};

export default InputPassword;
